<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'
</script>

<template>
  <ConfirmModal>
    <template #title>Are you sure you want to save formations?</template>
    <div>Number of players in formation is invalid.</div>
  </ConfirmModal>
</template>
